import React from 'react';

interface EventDrivenIconProps {
  className?: string;
}

const EventDrivenIcon: React.FC<EventDrivenIconProps> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M4 14C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H9C9.53043 2 10.0391 2.21071 10.4142 2.58579C10.7893 2.96086 11 3.46957 11 4V6.26733C11.3041 6.09177 11.649 5.99936 12.0002 5.99938C12.3513 5.99941 12.6962 6.09188 13.0003 6.26749C13.3043 6.4431 13.5568 6.69566 13.7323 6.99978C13.9078 7.30391 14.0001 7.64887 14 8V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H4ZM10 4C10 3.73478 9.89464 3.48043 9.70711 3.29289C9.51957 3.10536 9.26522 3 9 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V12C3 12.2652 3.10536 12.5196 3.29289 12.7071C3.48043 12.8946 3.73478 13 4 13H10V4ZM12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V13H12C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7Z" fill="currentColor"/>
      <path d="M8.2 9.66602C8.458 9.66602 8.66667 9.89002 8.66667 10.166C8.66667 10.442 8.458 10.666 8.2 10.666H4.46667C4.20867 10.666 4 10.442 4 10.166C4 9.89002 4.20867 9.66602 4.46667 9.66602H8.2ZM8.2 6.66602C8.458 6.66602 8.66667 6.89002 8.66667 7.16602C8.66667 7.44202 8.458 7.66602 8.2 7.66602H4.46667C4.20867 7.66602 4 7.44202 4 7.16602C4 6.89002 4.20867 6.66602 4.46667 6.66602H8.2Z" fill="currentColor"/>
    </svg>
  );
};

export default EventDrivenIcon;


